<template>
  <div
    v-if="(tableData && tableData.length > 0) || total > 0 || titleTotal > 0 || isQuestion || loading || showEmpty"
    class="bc-report-pagination-table"
    :class="{'credit-exam-pagination-table': isCreditExam}"
  >
    <div class="table-header">
      <div class="line" />
      <span>{{ title }}</span>
      <span
        v-if="(showTotal && total > 0) || (showTitleTotal && titleTotal > 0)"
        class="table-count"
      >{{ showTotal ? total : titleTotal }}</span>
    </div>
    <template>
      <slot
        name="transform"
        :data="tableData"
        :loading="loading"
      />
    </template>
    <el-table
      v-if="showTable"
      v-loading="loading"
      :border="border"
      :stripe="!isQuestion && showHeader && stripe"
      :show-header="!isQuestion && showHeader"
      :data="list"
      :span-method="tableSpanMethod"
      style="width: 100%"
      :cell-class-name="formatterCellClassName"
      @cell-click="tableCellClicked"
    >
      <div slot="empty">
        <span v-if="!loading">没有数据</span>
      </div>
      <el-table-column
        v-for="p in tableProps"
        :key="p.prop"
        :header-align="isQuestion ? '' : 'center'"
        :align="p.prop === '$index' ? 'center' : ''"
        :prop="p.prop"
        :label="p.label"
        :width="p.width"
        :column-key="p.customKey"
        :formatter="formatterColumn"
        :class-name="formatterClassName(p)"
      >
        <!-- <template slot-scope="scope"> -->
        <!-- eslint-disable-next-line vue/no-v-html vue/max-attributes-per-line -->
        <!-- <span class="column-txt text-overflow-mul" v-html="formatterScope(scope)" /> -->
        <!-- </template> -->
      </el-table-column>
    </el-table>
    <el-pagination
      v-show="!isQuestion && total > pageSize && showPager"
      class="table-pagination small"
      layout="prev, pager, next"
      :page-size="pageSize"
      :total="total"
      @current-change="currentPageChanged"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { buildValidURL } from '@/utils/http'
export default {
  name: 'BcReportPaginationTable',
  props: {
    isPageHand: Boolean,
    isQuestion: Boolean,
    isCreditExam: Boolean,
    loading: Boolean,
    showEmpty: Boolean,
    border: {
      type: Boolean,
      default: true
    },
    stripe: {
      type: Boolean,
      default: true
    },
    showTotal: {
      type: Boolean,
      default: true
    },
    showTitleTotal: {
      type: Boolean,
      default: true
    },
    showTable: {
      type: Boolean,
      default: true
    },
    showPager: {
      type: Boolean,
      default: true
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    tableData: {
      type: Array,
      default: () => []
    },
    tableProps: {
      type: Array,
      default: () => []
    },
    pageSize: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    titleTotal: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ''
    },
    pageIndex: {
      type: Number,
      default: 1
    },
    tableSpanMethod: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    list () {
      if (this.isPageHand && this.tableData.length === this.total) {
        let page = this.pageIndex
        let pageSize = this.pageSize
        return this.tableData.slice((page - 1) * pageSize, page * pageSize)
      }
      return this.tableData
    }
  },
  methods: {
    formatterClassName (p) {
      let names = ['table-column']
      p.className && names.push(p.className)
      this.isQuestion && names.push('question-table-column')
      if (p.customKey === '$link' || p.customKey === '$action') {
        names.push('link')
      }

      return names.join(' ')
    },
    formatterCellClassName ({ row, column, rowIndex, columnIndex }) {
      if (row.className && row.classLabel === column.label) {
        return row.className
      }
    },
    currentPageChanged (page) {
      this.$emit('pageChanged', page)
    },
    tableCellClicked (row, column, cell, event) {
      if (column.columnKey === '$link') {
        let value = row.link || row[column.property]
        if (!value) return
        let url = buildValidURL(value)
        let a = document.createElement('a')
        a.href = url
        a.target = '_blank'
        a.click()
        return
      }

      if (column.columnKey === '$action') {
        this.$emit('customAction', row)
      }
    },
    formatterScope (scope) {
      let column = scope.column
      let row = scope.row
      let prop = column.property
      let cellValue = row[prop]
      return this.formatterColumn(row, column, cellValue, scope.$index)
    },
    formatterColumn (row, column, cellValue, index) {
      if (column.property === '$index') {
        return index + (this.pageIndex - 1) * this.pageSize + 1
      }
      if (!cellValue) return '-'
      if (cellValue === '$space') return ''
      if (column.columnKey === '$timestamp') {
        let timestamp = parseInt(cellValue)
        if (timestamp > 9999) {
          return dayjs(parseInt(cellValue)).format('YYYY-MM-DD')
        }
      } else if (column.columnKey === '$unit_money') {
        return cellValue + '万元'
      }
      return cellValue
    }
  }
}
</script>

<style lang="stylus">
.bc-report-pagination-table
  margin-top 30px
  .table-header
    height 20px
    font-size 14px
    color #8590a6
    display flex
    align-items center
    margin-bottom 10px
    .line
      background-color #8590a6
      display inline-block
      width 2px
      height 12px
      margin-right 8px
    .table-count
      color $color-theme
      margin-left 10px
  .table-column
    font-size 12px
    padding 10px 0
    &.question-table-column .cell
      line-height 16px
    .cell
      line-height 14px
    .column-txt
      max-height 28px
      -webkit-line-clamp 2
    &.link
      // text-decoration underline
      cursor pointer
      &:hover
        color $color-theme
  th
    padding 5px 0 !important
    background-color #8590a6 !important
    color #fff !important
  .table-pagination
    text-align right
    margin-top 20px
  &.credit-exam-pagination-table
    .table-header
      font-size 16px
      color $color-txt
      font-weight 600
      border-bottom 1px solid #EBEBEB
      height 50px
      margin-bottom 20px
      .line
        background-color transparent !important
      .table-count
        font-weight 400
        color #9B9B9B
</style>
